/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipReportEvidenceExportUrl0QueryResponse, GetGipReportEvidenceExportUrl0PathParams, GetGipReportEvidenceExportUrl0404 } from "../models/GetGipReportEvidenceExportUrl0";

export function getGetGipReportEvidenceExportUrl0Url(id: GetGipReportEvidenceExportUrl0PathParams["id"]) {
  const res = { method: 'GET', url: `/reports/gip/report/${id}/evidence-export-url` as const }
  return res
}

/**
 * @summary Get export URL for existing report
 * {@link /reports/gip/report/:id/evidence-export-url}
 */
export async function getGipReportEvidenceExportUrl0(id: GetGipReportEvidenceExportUrl0PathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetGipReportEvidenceExportUrl0QueryResponse, ResponseErrorConfig<GetGipReportEvidenceExportUrl0404>, unknown>({ method : "GET", url : getGetGipReportEvidenceExportUrl0Url(id).url.toString(), ... requestConfig })
  return res.data
}